import script from "./MessageImage.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageImage.vue?vue&type=script&setup=true&lang=js"

import "./MessageImage.vue?vue&type=style&index=0&id=3b57a96d&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b57a96d"]])

export default __exports__